function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 14H6C6 14.5304 6.21071 15.0391 6.58579 15.4142C6.96086 15.7893 7.46957 16 8 16C8.53043 16 9.03914 15.7893 9.41421 15.4142C9.78929 15.0391 10 14.5304 10 14Z",
  fill: "#2D3748"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 3,
  r: 3,
  fill: "#2D3748"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15 11H14.5C14.0639 10.6241 13.7068 10.1653 13.4493 9.65035C13.1918 9.13538 13.0391 8.57443 13 8C12.0802 8.0028 11.1776 7.75108 10.392 7.27268C9.60643 6.79427 8.96852 6.10785 8.54887 5.28938C8.12923 4.4709 7.94422 3.55227 8.01431 2.63516C8.0844 1.71805 8.40685 0.838206 8.946 0.0930008C8.63419 0.03305 8.31752 0.00191876 8 7.92032e-07C7.34157 -0.00654858 6.68845 0.118308 6.07886 0.367262C5.46928 0.616216 4.91547 0.984267 4.44987 1.44987C3.98427 1.91547 3.61622 2.46928 3.36726 3.07886C3.11831 3.68845 2.99345 4.34157 3 5V8C2.9609 8.57443 2.80818 9.13538 2.5507 9.65035C2.29321 10.1653 1.93608 10.6241 1.5 11H1C0.734784 11 0.48043 11.1054 0.292893 11.2929C0.105357 11.4804 0 11.7348 0 12C0 12.2652 0.105357 12.5196 0.292893 12.7071C0.48043 12.8946 0.734784 13 1 13H15C15.2652 13 15.5196 12.8946 15.7071 12.7071C15.8946 12.5196 16 12.2652 16 12C16 11.7348 15.8946 11.4804 15.7071 11.2929C15.5196 11.1054 15.2652 11 15 11Z",
  fill: "#2D3748"
});

var SvgAlerts = function SvgAlerts(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlerts, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Alerts.84df19b7.svg";
export { ForwardRef as ReactComponent };